import React from "react";
import "./TitleTextFragment.css";

interface myComponentProps {
  title?: string;
  text?: string;
  titleColor?: string;
  textColor?: string;
  titleSize?: string;
  textSize?: string;
  className?: string;
}

const TitleTextFragment = ({
  text,
  textColor,
  textSize,
  title,
  titleColor,
  titleSize,
  className,
}: myComponentProps) => {
  return (
    <span
      style={
        {
          "--text-color": textColor || "rgba(89, 96, 128, 1)",
          "--title-color": titleColor || "rgba(89, 96, 128, 1)",
          "--text-size": textSize || "1.2rem",
          "--title-size": titleSize || "1.65rem",
        } as React.CSSProperties
      }
      className={`title-text-fragment-reuse-wrapper-index ${className || ""}`}
    >
      {title && <span className="title">{title || ""}</span>}
      {text && <span className="text">{text || ""}</span>}
    </span>
  );
};

export default TitleTextFragment;
